var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPeriodDrama = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "History-Woman-Queen--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "History Woman Queen Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7 18.42a2.06 2.06 0 0 0 1.27 -0.92A6.55 6.55 0 0 0 12 19.25a6.72 6.72 0 0 0 4 -2 2.06 2.06 0 0 0 1.43 1.15c1.68 0.41 3.56 -0.88 4.17 -1.63a0.54 0.54 0 0 0 0.09 -0.46 0.52 0.52 0 0 0 -0.33 -0.33c-1.32 -0.44 -2 -2.07 -2.27 -3.43a3.45 3.45 0 0 0 0.17 -0.94 2.05 2.05 0 0 0 -0.64 -1.61l-0.07 -0.2a0.49 0.49 0 0 0 0.08 -0.21c0.25 -2.3 0.87 -8.06 0.87 -8.06a0.5 0.5 0 0 0 -0.76 -0.48l-3.46 2.18a0.25 0.25 0 0 1 -0.32 0l-2.58 -3a0.52 0.52 0 0 0 -0.76 0L9 3.18a0.25 0.25 0 0 1 -0.32 0L5.26 1.07a0.5 0.5 0 0 0 -0.76 0.48l0.92 8a0.38 0.38 0 0 0 0 0.15l-0.04 0.3a2.05 2.05 0 0 0 -0.63 1.61 3.17 3.17 0 0 0 0.42 1.49c-0.35 1.22 -1 2.5 -2.13 2.88a0.5 0.5 0 0 0 -0.23 0.79c0.58 0.74 2.48 2.06 4.19 1.65Zm5 -0.67c-1 0 -3.82 -1.49 -4.19 -3.74a1.75 1.75 0 0 0 -1 -1.31 1.27 1.27 0 0 1 -0.56 -1.09 0.69 0.69 0 0 1 0.1 -0.44 0.71 0.71 0 0 0 0.38 -0.45l0.31 -1a0.25 0.25 0 0 1 0.16 -0.16 15 15 0 0 1 9.6 0 0.28 0.28 0 0 1 0.16 0.16l0.31 1a0.71 0.71 0 0 0 0.38 0.45 0.69 0.69 0 0 1 0.1 0.44 1.27 1.27 0 0 1 -0.56 1.09 1.75 1.75 0 0 0 -1 1.31c-0.37 2.25 -3.19 3.74 -4.19 3.74Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.74 14.32a1.94 1.94 0 0 1 -1.63 0 0.76 0.76 0 0 0 -1 0.31 0.75 0.75 0 0 0 0.31 1 3.21 3.21 0 0 0 1.53 0.36 3.32 3.32 0 0 0 1.53 -0.36 0.74 0.74 0 0 0 0.3 -1 0.76 0.76 0 0 0 -1.04 -0.31Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12a0.76 0.76 0 0 0 -0.06 -1 2.11 2.11 0 0 0 -2.64 0 0.75 0.75 0 0 0 -0.05 1 0.76 0.76 0 0 0 1.06 0.06 0.62 0.62 0 0 1 0.62 0A0.76 0.76 0 0 0 11 12Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87 11a0.75 0.75 0 0 0 1 1.12 0.64 0.64 0 0 1 0.63 0 0.75 0.75 0 1 0 1 -1.12 2.09 2.09 0 0 0 -2.63 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2 24a0.52 0.52 0 0 0 0.41 -0.22 0.52 0.52 0 0 0 0.05 -0.47 4.49 4.49 0 0 0 -2.58 -2.53L16 19.5a0.56 0.56 0 0 0 -0.43 0.09l-3.45 2.66a0.24 0.24 0 0 1 -0.3 0l-3.43 -2.66A0.48 0.48 0 0 0 8 19.5l-5 1.28a4.49 4.49 0 0 0 -2.66 2.53 0.52 0.52 0 0 0 0 0.47 0.52 0.52 0 0 0 0.46 0.22Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPeriodDrama);
export default ForwardRef;